(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["benefits-card-v2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.benefits-card-v2').forEach((card) => {
      const defaultView = card.querySelector('.benefits-card-v2-default')
      const buttonsWrap = card.querySelector('.benefits-card-v2-buttons')
      const exitBtnWrap = card.querySelector('.benefits-card-v2-exit')

      // If any key element is missing, skip this card
      if (!defaultView || !buttonsWrap || !exitBtnWrap) return

      let activeScreen = defaultView

      const showExit = () => exitBtnWrap.classList.remove('hidden')
      const hideExit = () => exitBtnWrap.classList.add('hidden')

      const openFrequency = (idx) => {
        const target = card.querySelector(`.frequency-${idx}-wrapper`)
        if (!target || target === activeScreen) return

        // hide current
        activeScreen.classList.add('hidden')

        // show target
        activeScreen = target
        activeScreen.classList.remove('hidden')

        // (optional) change bg while in frequency mode
        card.style.background = 'linear-gradient(90deg, #BE94E1 0%, #D9B5C3 100%)'

        // show the × button
        showExit()
      }

      const resetToDefault = () => {
        if (activeScreen !== defaultView) {
          // hide current frequency screen
          activeScreen.classList.add('hidden')

          // show default
          defaultView.classList.remove('hidden')
          activeScreen = defaultView
        }

        // restore bg + hide ×
        card.style.background = 'white'
        hideExit()
      }

      // Buttons -> open frequency
      buttonsWrap.querySelectorAll('[data-frq-btn]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const idx = btn.getAttribute('data-frq-btn')
          openFrequency(idx)
        })
      })

      // “×” click -> reset to default
      exitBtnWrap.addEventListener('click', (e) => {
        e.preventDefault()
        resetToDefault()
      })
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["landing-blog-image-carousel"] && !Shopify.designMode) return;
  try {
    var swiper = new Swiper('.landing-blog-carousel', {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-atc"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-pdp-atc]').forEach(function (root) {
    const input = root.querySelector('.pdp-atc__qty-input')
    const add = root.querySelector('add-to-cart')
    if (!input || !add) return

    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10)
        if (next < 1 || next > 9) return
        input.value = next
        add.setAttribute('quantity', next)
      })
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["prd-atc"] && !Shopify.designMode) return;
  try {
    const prdAtcQtyInput = document.getElementById('product-atc-quantity')
  const prdAtcMinus = document.getElementById('product-atc-quantity-minus')
  const prdAtcPlus = document.getElementById('product-atc-quantity-plus')
  const prdAtcAdd = document.getElementById('product-atc-component')

  function prdSyncQty() {
    if (prdAtcAdd) prdAtcAdd.setAttribute('quantity', prdAtcQtyInput.value)
  }

  prdAtcMinus.addEventListener('click', () => {
    const q = parseInt(prdAtcQtyInput.value, 10)
    if (q > 1) prdAtcQtyInput.value = q - 1
    prdSyncQty()
  })
  prdAtcPlus.addEventListener('click', () => {
    const q = parseInt(prdAtcQtyInput.value, 10)
    if (q < 9) prdAtcQtyInput.value = q + 1
    prdSyncQty()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-add-to-cart-quantity-sticker-bundles"] && !Shopify.designMode) return;
  try {
    const productAtcForm = document.getElementById('product-add-to-cart-form')
  const quantityInput = document.getElementById('product-atc-stickers-quantity')
  const quantityMinusButton = document.getElementById('product-atc-stickers-quantity-minus')
  const quantityPlusButton = document.getElementById('product-atc-stickers-quantity-plus')
  const addToCartEl = document.getElementById('product-atc-stickers-component')

  function syncAddToCartQty() {
    if (addToCartEl) addToCartEl.setAttribute('quantity', quantityInput.value)
  }

  const priceSection = document.getElementById('product-atc-stickers-price')
  const price = priceSection.querySelector('.price')
  const priceCompare = priceSection.querySelector('.price-compare')
  const bundleElements = document.querySelectorAll('.product-atc-stickers-bundle')
  const currencySymbol = price.dataset.currency

  function updatePrice() {
    if (quantityInput.value < 6) {
      price.innerText = `${currencySymbol}${((parseInt(price.dataset.value) * quantityInput.value) / 100).toFixed(2)}`
      if (priceCompare) {
        priceCompare.innerText = `${currencySymbol}${
          (parseInt(priceCompare.dataset.value) * quantityInput.value) / 100
        }`
      }
    } else if (quantityInput.value >= 6) {
      price.innerText = `${currencySymbol}${((22000 + price.dataset.value * (quantityInput.value - 6)) / 100).toFixed(
        2
      )}`
      if (priceCompare) {
        priceCompare.innerText = `${currencySymbol}${
          (parseInt(priceCompare.dataset.value) * quantityInput.value) / 100
        }`
      }
    }
  }

  function updateBundleSelection() {
    bundleElements.forEach((bundleElement) => {
      bundleElement.classList.remove('selected-bundle')
    })
    if (quantityInput.value == 2) {
      bundleElements[0].classList.add('selected-bundle')
    } else if (quantityInput.value == 3 || quantityInput.value == 4) {
      bundleElements[1].classList.add('selected-bundle')
    } else if (quantityInput.value == 6 || quantityInput.value == 7) {
      bundleElements[2].classList.add('selected-bundle')
    } else if (quantityInput.value == 5) {
      bundleElements[0].classList.add('selected-bundle')
      bundleElements[1].classList.add('selected-bundle')
    } else if (quantityInput.value == 8) {
      bundleElements[0].classList.add('selected-bundle')
      bundleElements[2].classList.add('selected-bundle')
    }
  }
  bundleElements.forEach((bundleElement, index) => {
    bundleElement.addEventListener('click', function () {
      if (index == 0) {
        quantityInput.value = 2
      } else if (index == 1) {
        quantityInput.value = 3
      } else if (index == 2) {
        quantityInput.value = 6
      }
      updateAtcUi()
    })
  })

  function updateAtcUi() {
    updatePrice()
    updateBundleSelection()
    syncAddToCartQty()
  }
  quantityMinusButton.addEventListener('click', function () {
    let currentQuantity = parseInt(quantityInput.value)
    if (currentQuantity > 1) {
      quantityInput.value = currentQuantity - 1
    }
    updateAtcUi()
  })
  quantityPlusButton.addEventListener('click', function () {
    let currentQuantity = parseInt(quantityInput.value)
    if (currentQuantity < 9) {
      quantityInput.value = currentQuantity + 1
    }
    updateAtcUi()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["schummi-pdp"] && !Shopify.designMode) return;
  try {
    ;(function () {
    /* ── Live backend ───────────────────────────────────────────────────── */
    var ENDPOINT = 'https://agent.theschumann.com/api/chat'
    var ERROR_REPLY = 'Sorry, something went wrong — please try again.'

    /* Shared with sections/schummi-chat-ai-page.liquid: one visitor, one
       server-side thread across the PDP block and the full chat page. */
    var SESSION_KEY = 'sca_session_id'
    var SESSION_TTL_MS = 7 * 24 * 60 * 60 * 1000 /* 7 days */

    /* localStorage throws in some privacy modes, and a lost session id only
       costs the visitor their follow-up context. */
    function readSession() {
      try {
        var raw = localStorage.getItem(SESSION_KEY)
        if (!raw) return null
        var rec = JSON.parse(raw)
        if (rec && rec.id && typeof rec.exp === 'number' && rec.exp > Date.now()) {
          return rec.id
        }
      } catch (e) {}
      return null
    }
    function saveSession(id) {
      if (!id) return
      try {
        /* Rolling 7-day TTL: refreshed on every meta frame that carries an id. */
        localStorage.setItem(SESSION_KEY, JSON.stringify({ id: id, exp: Date.now() + SESSION_TTL_MS }))
      } catch (e) {}
    }

    /* ── Product catalog (for recommendation cards) ──────────────────────
       The agent's `recommendation` event carries only the display NAME, so we
       resolve it to live Shopify data rendered into the block body as JSON. */
    function normName(s) {
      return (s || '').toString().toLowerCase().replace(/\s+/g, ' ').trim()
    }
    /* Display name → Shopify handle. Mirrors schummi-ai-agent's PRODUCT_CATALOG
       so cards still resolve if a catalog name drifts from the storefront title. */
    var NAME_TO_HANDLE = {
      'v3 max': 'the-schumann-v3',
      'v2 pro': 'the-schumann-v2',
      'v1 classic': 'the-schumann-v1',
      'emf nano shield': 'emf-sticker',
      'frequency water bottle': 'frequency-water-bottle',
      'charging station': 'charger-dock',
      'frequency guide book': 'frequency-guide-book',
      'schumann tote bag': 'tote-bag',
      'the schumann e-book': 'e-book',
      'schumann v3 pouch': 'schumann-v3-pouch',
    }
    var BY_HANDLE = {}
    var BY_NAME = {}
    ;(function loadCatalog() {
      var nodes = document.querySelectorAll('script.schummi-pdp-product')
      for (var i = 0; i < nodes.length; i++) {
        var handle = nodes[i].getAttribute('data-handle')
        var data
        try {
          data = JSON.parse(nodes[i].textContent)
        } catch (e) {
          continue
        }
        if (!data) continue
        data.handle = handle
        if (handle) BY_HANDLE[handle] = data
        if (data.name) BY_NAME[normName(data.name)] = data
      }
    })()

    /* Alias map first, then a direct title match. Returns null when the name is
       unknown — a card with no price or link is worse than no card. */
    function resolveProduct(name) {
      var key = normName(name)
      var handle = NAME_TO_HANDLE[key]
      return (handle && BY_HANDLE[handle]) || BY_NAME[key] || null
    }

    /* ── markdown-lite → DOM ────────────────────────────────────────────── */
    function appendInline(parent, text) {
      var parts = text.split(/(\*\*[^*]+\*\*)/g)
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i]
        if (/^\*\*[^*]+\*\*$/.test(p)) {
          var strong = document.createElement('strong')
          strong.textContent = p.slice(2, -2)
          parent.appendChild(strong)
        } else if (p) {
          parent.appendChild(document.createTextNode(p))
        }
      }
    }

    function buildRichText(text) {
      var frag = document.createDocumentFragment()
      var lines = text.split('\n')
      var i = 0
      while (i < lines.length) {
        var line = lines[i]
        if (/^\s*-\s+/.test(line)) {
          var ul = document.createElement('ul')
          while (i < lines.length && /^\s*-\s+/.test(lines[i])) {
            var li = document.createElement('li')
            appendInline(li, lines[i].replace(/^\s*-\s+/, ''))
            ul.appendChild(li)
            i++
          }
          frag.appendChild(ul)
        } else if (/^\s*\d+\.\s+/.test(line)) {
          var ol = document.createElement('ol')
          while (i < lines.length && /^\s*\d+\.\s+/.test(lines[i])) {
            var oli = document.createElement('li')
            appendInline(oli, lines[i].replace(/^\s*\d+\.\s+/, ''))
            ol.appendChild(oli)
            i++
          }
          frag.appendChild(ol)
        } else if (line.trim() === '') {
          i++
        } else {
          var p = document.createElement('p')
          appendInline(p, line)
          frag.appendChild(p)
          i++
        }
      }
      return frag
    }

    /* Entries are cloned from a template, so aria-controls needs an id minted
       per answer rather than baked into the markup. */
    var entryUid = 0

    /* Parse one SSE frame (its "event:" + "data:" lines) into { event, data },
       or null when there is no parseable JSON payload. */
    function parseFrame(frame) {
      var event = 'message'
      var dataLines = []
      var lines = frame.split('\n')
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i]
        if (line.indexOf('event:') === 0) {
          event = line.slice(6).trim()
        } else if (line.indexOf('data:') === 0) {
          dataLines.push(line.slice(5).trim())
        }
      }
      if (!dataLines.length) return null
      try {
        return { event: event, data: JSON.parse(dataLines.join('\n')) }
      } catch (e) {
        return null
      }
    }

    class SchummiPdp extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-form]')
        this.input = this.querySelector('[data-input]')
        this.submit = this.querySelector('[data-ask]')
        this.thread = this.querySelector('[data-thread]')
        this.chips = this.querySelector('[data-chips]')
        this.entryTemplate = this.querySelector('[data-entry-template]')

        this.busy = false
        this.controller = null

        this.input.addEventListener('input', () => this.syncAskState())

        this.form.addEventListener('submit', (event) => {
          event.preventDefault()
          this.ask(this.input.value.trim())
        })

        // Keep focus on the input when the button is tapped. On iOS Safari the
        // button would otherwise blur the input first, dismissing the keyboard
        // and reflowing the page out from under the tap.
        this.submit.addEventListener('mousedown', (event) => event.preventDefault())

        // Older answers live on as collapsed question rows; the caret re-opens
        // them. The newest can be folded away the same way.
        this.thread.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-q-toggle]')
          if (!toggle) return
          const entry = toggle.closest('.schummi-pdp__entry')
          this.setCollapsed(entry, !entry.hasAttribute('data-collapsed'))
        })

        if (this.chips) {
          this.chips.addEventListener('click', (event) => {
            const chip = event.target.closest('[data-chip]')
            if (chip) this.ask(chip.dataset.question)
          })
        }

        this.syncAskState()
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort()
      }

      setCollapsed(entry, collapsed) {
        if (!entry) return
        entry.toggleAttribute('data-collapsed', collapsed)
        const toggle = entry.querySelector('[data-q-toggle]')
        if (toggle) toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true')
      }

      syncAskState() {
        const filled = this.input.value.trim().length > 0
        this.toggleAttribute('data-typing', filled && !this.busy)
        this.toggleAttribute('data-busy', this.busy)
        this.submit.disabled = !filled || this.busy
      }

      // The endpoint takes a bare message, so the page the question was asked on
      // travels as a trailing note — "What it does" is unanswerable without it.
      contextualize(question) {
        const title = this.dataset.productTitle
        return title ? question + '\n\n(Asked on the ' + title + ' product page.)' : question
      }

      ask(question) {
        if (!question || this.busy) return

        this.busy = true
        this.input.value = ''
        this.syncAskState()

        // Only the newest answer carries the recommendation — a second copy under
        // an older answer would just repeat the same offer.
        this.thread.querySelectorAll('[data-rec]').forEach((node) => node.remove())
        this.thread
          .querySelectorAll('.schummi-pdp__entry')
          .forEach((node) => this.setCollapsed(node, true))

        const entry = this.entryTemplate.content.firstElementChild.cloneNode(true)
        entry.querySelector('[data-q]').textContent = question

        const bodyId = 'schummi-pdp-answer-' + ++entryUid
        entry.querySelector('[data-body]').id = bodyId
        entry.querySelector('[data-q-toggle]').setAttribute('aria-controls', bodyId)

        this.thread.appendChild(entry)

        this.stream(question, entry)
      }

      stream(question, entry) {
        const answer = entry.querySelector('[data-a]')
        let text = ''
        let started = false
        let rec = null

        // The thinking line holds until the first token actually lands.
        const paint = () => {
          if (!started) {
            started = true
            const thinking = entry.querySelector('[data-thinking]')
            if (thinking) thinking.remove()
            entry.setAttribute('data-streaming', '')
          }
          answer.replaceChildren(buildRichText(text))
        }

        const finish = (failed) => {
          // Also covers a stream that closed clean but empty — otherwise the
          // thinking line would sit there forever.
          if (!text) {
            text = ERROR_REPLY
            paint()
          }
          entry.removeAttribute('data-streaming')
          // Card goes in before aria-busy drops, so it rides the same
          // announcement as the answer instead of a second one after it.
          if (!failed && rec) this.recommend(entry, rec)
          entry.setAttribute('aria-busy', 'false')
          this.busy = false
          this.controller = null
          this.syncAskState()
        }

        this.controller = new AbortController()

        fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: readSession(), message: this.contextualize(question) }),
          signal: this.controller.signal,
        })
          .then((res) => {
            if (!res.ok || !res.body) throw new Error('HTTP ' + res.status)
            const reader = res.body.getReader()
            const decoder = new TextDecoder()
            let buffer = ''

            const pump = () =>
              reader.read().then((r) => {
                buffer += decoder.decode(r.value || new Uint8Array(), { stream: !r.done }).replace(/\r/g, '')
                let idx
                while ((idx = buffer.indexOf('\n\n')) !== -1) {
                  const frame = buffer.slice(0, idx)
                  buffer = buffer.slice(idx + 2)
                  if (!frame.trim()) continue
                  const parsed = parseFrame(frame)
                  if (!parsed) continue
                  if (parsed.event === 'meta') {
                    saveSession(parsed.data.session_id)
                  } else if (parsed.event === 'delta') {
                    if (parsed.data.text) {
                      text += parsed.data.text
                      paint()
                    }
                  } else if (parsed.event === 'recommendation') {
                    rec = parsed.data
                  } else if (parsed.event === 'error') {
                    throw new Error(parsed.data.message || 'stream error')
                  }
                }
                if (r.done) return
                return pump()
              })

            return pump()
          })
          .then(() => finish(false))
          .catch((error) => {
            if (error && error.name === 'AbortError') return
            console.error('Schummi PDP:', error)
            finish(true)
          })
      }

      /* Render the agent's suggestion as the design's recommendation row.
         Skipped when the name does not resolve, or when it resolves to the
         product this PDP is already selling. */
      recommend(entry, rec) {
        const product = resolveProduct(rec && rec.product)
        if (!product) return
        if (product.handle && product.handle === this.dataset.productHandle) return

        const asAtc = this.dataset.recAction !== 'link' && product.available && product.variantId
        const ctaLabel = this.dataset.recCta || 'Add to Cart'

        let card
        if (asAtc) {
          // data-fixed-variant keeps the PDP's variant pickers from rewriting
          // this variant-id — this is a side-product ATC, not the main one.
          card = document.createElement('add-to-cart')
          card.setAttribute('data-fixed-variant', '')
          card.setAttribute('variant-id', String(product.variantId))
          if (product.priceCents != null) card.setAttribute('data-price', String(product.priceCents))
        } else {
          card = document.createElement('a')
          card.href = product.url || '#'
          card.setAttribute('rel', 'noopener')
        }
        card.className = 'schummi-pdp__rec'
        card.setAttribute('data-rec', '')

        if (product.image) {
          const img = document.createElement('img')
          img.className = 'schummi-pdp__rec-media'
          img.src = product.image
          img.alt = ''
          img.width = 40
          img.height = 40
          img.loading = 'lazy'
          card.appendChild(img)
        } else {
          const placeholder = document.createElement('span')
          placeholder.className = 'schummi-pdp__rec-media'
          placeholder.setAttribute('aria-hidden', 'true')
          card.appendChild(placeholder)
        }

        const textWrap = document.createElement('span')
        textWrap.className = 'schummi-pdp__rec-text'
        const title = document.createElement('span')
        title.className = 'schummi-pdp__rec-title'
        title.textContent = product.name || ''
        textWrap.appendChild(title)

        const sub = document.createElement('span')
        sub.className = 'schummi-pdp__rec-sub'
        if (product.price) sub.appendChild(document.createTextNode(product.price))
        if (rec.discountPercent > 0 && rec.discountCode) {
          if (sub.childNodes.length) sub.appendChild(document.createTextNode(' · '))
          const code = document.createElement('span')
          code.className = 'schummi-pdp__rec-code'
          code.textContent = 'Save ' + rec.discountPercent + '% · ' + rec.discountCode
          sub.appendChild(code)
        }
        if (sub.childNodes.length) textWrap.appendChild(sub)
        card.appendChild(textWrap)

        const cta = document.createElement(asAtc ? 'button' : 'span')
        cta.className = 'schummi-pdp__rec-cta'
        if (asAtc) cta.type = 'button'
        cta.textContent = ctaLabel
        card.appendChild(cta)

        // Inside the body, so folding the entry takes the offer with it.
        ;(entry.querySelector('[data-body-inner]') || entry).appendChild(card)
      }
    }

    if (!customElements.get('schummi-pdp')) {
      customElements.define('schummi-pdp', SchummiPdp)
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["v3-atc"] && !Shopify.designMode) return;
  try {
    const productAtcForm = document.getElementById('product-add-to-cart-form')
  const quantityInput = document.getElementById('product-atc-quantity')
  const quantityMinusButton = document.getElementById('product-atc-quantity-minus')
  const quantityPlusButton = document.getElementById('product-atc-quantity-plus')
  const addToCartEl = document.getElementById('product-atc-component')

  function syncAddToCartQty() {
    if (addToCartEl) addToCartEl.setAttribute('quantity', quantityInput.value)
  }

  const productAtcProgressBar = document.getElementById('product-atc-progress-bar')
  const progressFill = productAtcProgressBar.querySelector('.product-atc-progress-bar-fill')
  const potentialProgressFill = productAtcProgressBar.querySelector('.product-atc-progress-bar-fill-potential')
  let cartTotal = parseInt(progressFill.dataset.cartTotal)
  const goalMax = parseInt(progressFill.dataset.goalMax)
  const giftPrices = progressFill.dataset.giftPrices.split(',')
  const giftCheckpoints = productAtcProgressBar.querySelectorAll('.product-atc-progress-bar-gift')
  const nextGiftTitle = document.getElementById('product-atc-next-gift-title')
  const nextGiftLeft = document.getElementById('product-atc-next-gift-left')

  const priceSection = document.getElementById('product-atc-price')
  const price = priceSection.querySelector('.price')
  const priceCompare = priceSection.querySelector('.price-compare')
  const currencySymbol = price.dataset.currency

  function timingFunction(t) {
    x0 = 1
    y0 = 1
    x1 = -0.143
    y1 = 1
    x2 = 0.07
    y2 = 0.425
    x3 = 0
    y3 = 0
    const xt =
      (1 - t) * ((1 - t) * ((1 - t) * x0 + t * x1) + t * ((1 - t) * x1 + t * x2)) +
      t * ((1 - t) * ((1 - t) * x1 + t * x2) + t * ((1 - t) * x2 + t * x3))
    const yt =
      (1 - t) * ((1 - t) * ((1 - t) * y0 + t * y1) + t * ((1 - t) * y1 + t * y2)) +
      t * ((1 - t) * ((1 - t) * y1 + t * y2) + t * ((1 - t) * y2 + t * y3))
    return xt
  }

  giftCheckpoints.forEach((checkpoint, index) => {
    const goalNumber = parseInt(checkpoint.dataset.goalNumber)
    const progressPercentage = timingFunction(1 - goalNumber / goalMax)
    checkpoint.style.left = `${Math.min(progressPercentage * 100, 100)}%`
  })

  function updateGiftProgress() {
    let nextGift = undefined
    for (const checkpoint of giftCheckpoints) {
      const goalNumber = parseInt(checkpoint.dataset.goalNumber)
      if (cartTotal < goalNumber) {
        nextGift = checkpoint
        break
      }
    }
    if (nextGift === undefined) {
      nextGiftTitle.innerText = `All Gifts Unlocked!`
      nextGiftLeft.innerText = ``
    } else {
      nextGiftTitle.innerText = `to free ${nextGift.dataset.title.toLowerCase()}`
      nextGiftLeft.innerText = `${currencySymbol}${(nextGift.dataset.goalNumber - cartTotal) / 100} left`
    }

    const newCartTotal = parseInt(price.dataset.value) * parseInt(quantityInput.value) + cartTotal
    const cartProgressPercentage = timingFunction(1 - cartTotal / goalMax)
    const progressPercentage = timingFunction(1 - newCartTotal / goalMax)
    giftCheckpoints.forEach((checkpoint, index) => {
      const goalNumber = parseInt(checkpoint.dataset.goalNumber)
      if (cartTotal >= goalNumber) {
        checkpoint.classList.add('product-atc-progress-bar-gift-reached')
      } else {
        checkpoint.classList.remove('product-atc-progress-bar-gift-reached')
      }
    })
    if (newCartTotal >= goalMax) {
      potentialProgressFill.style.width = `100%`
    } else potentialProgressFill.style.width = `${Math.min(progressPercentage * 100, 100)}%`
    if (cartTotal >= goalMax) {
      progressFill.style.width = `100%`
    } else progressFill.style.width = `${Math.min(cartProgressPercentage * 100, 100)}%`
  }
  updateGiftProgress()

  quantityMinusButton.addEventListener('click', function () {
    let currentQuantity = parseInt(quantityInput.value)
    if (currentQuantity > 1) {
      quantityInput.value = currentQuantity - 1
    }
    syncAddToCartQty()
    updateGiftProgress()
  })
  quantityPlusButton.addEventListener('click', function () {
    let currentQuantity = parseInt(quantityInput.value)
    if (currentQuantity < 9) {
      quantityInput.value = currentQuantity + 1
    }
    syncAddToCartQty()
    updateGiftProgress()
  })
  } catch(e) { console.error(e); }
})();

})();
